export default {
    attachments: '/attachments',
};
